import { useCallback } from 'react';

import { useToast } from '../../hooks/useToast';

export function usePreferenceToast() {
  const toast = useToast();

  const showToast = useCallback(
    (
      message: string,
      status: 'success' | 'error' = 'error',
      options?: { description?: string; duration?: number; error?: unknown }
    ) => {
      if (options?.error) {
        console.error('[UserPreferencesModal]', message, options.error);
      }

      toast({
        title: message,
        description: options?.description,
        status,
        duration: options?.duration || 4000,
        isClosable: true,
        position: 'top-right',
      });
    },
    [toast]
  );

  return showToast;
}
